import { configureStore, combineReducers } from "@reduxjs/toolkit";
// import { combineReducers } from 'redux'

import scheduler from "./scheduler";
import events from "./events";

export const reducer = combineReducers({
  scheduler,
  events,
});

const store = configureStore({
  reducer: {
    scheduler: scheduler,
    events: events,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
